import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiAlignRight, FiXCircle } from "react-icons/fi";
import "./Navbarmenu.css";
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import superAdminList from "../superadmins.json";
import { fetchAdminUser } from "./Redux/AdminUserSlice";
import { useTabContext } from "../TabContext";

const Navbarmenu = ({items}) => {
  const { setActivePage } = useTabContext()
  const dispatch = useDispatch();

  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount) loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  useEffect(() => {
    if(loggedInEnterpriseId){
    dispatch(fetchAdminUser(loggedInEnterpriseId))
    }
  }, [])
  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row-fluid">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiXCircle />
                  </span>
                </>
              ) : (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiAlignRight />
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
                {items?.map((item,idx)=>
                  <li key={idx} className="menu-item">
                     <NavLink
                      activeClassName="is-active"
                      className="nav-links"
                      onClick={toggleClass}
                      exact
                      to={item.path}
                  >
                    {item.name}
                  </NavLink>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbarmenu;
